import { Grid } from "@mui/material";
import CardView from "../../../components/common/CardView";
import React, { useState } from "react";
import dayjs from "dayjs";
import ManageRelevent from "./ManageRelevent";
import ManageLead from "./ManageLead";
import { useSelector } from "react-redux";
import { setNotificationAction } from "../../../store/reducers/mmymSlice";
import { useDispatch } from "react-redux";

interface LeadCardDetailsProps {
  leadDetails: any;
}

const LeadCardDetails: React.FC<LeadCardDetailsProps> = ({ leadDetails }) => {
  const dispatch = useDispatch();
  const { user, userProfile, leadModulePermission } = useSelector(
    (state: any) => state?.user,
  );
  const [selectedLead, setSelectedLead] = useState(null);
  const [open, setOpen] = useState(false);
  const [openRelevant, setOpenRelevant] = useState(false);
  const leadCardDetailsFields = [
    {
      title: "Customer Details",
      isEdit: true,
      // isLogo:true,
      name: `${leadDetails?.lead?.customer_prefix ? leadDetails?.lead?.customer_prefix + " - " : ""}${
        leadDetails?.lead ? leadDetails?.lead?.customer_name : "Unknown"
      }`,
      phone: `${
        leadDetails?.lead &&
        leadDetails?.lead?.customer_country_code &&
        leadDetails?.lead?.customer_phone
          ? `${leadDetails?.lead?.customer_country_code}${leadDetails?.lead?.customer_phone}`
          : `${leadDetails?.lead?.customer_phone ? leadDetails?.lead?.customer_phone : "Phone Number"}`
      }`,
      phoneDuplicateVal: `${leadDetails?.lead?.same_phone_count ? leadDetails?.lead?.same_phone_count : null}`,
      email: `${
        leadDetails?.lead ? leadDetails?.lead?.customer_email : "EMail"
      }`,
      emailDuplicateVal: `${leadDetails?.lead?.same_email_count ? leadDetails?.lead?.same_email_count : null}`,
      sales: `${
        leadDetails?.lead?.sales_person_name
          ? leadDetails?.lead?.sales_person_name
          : "N/A"
      }`,
    },
    {
      title: "Relevant Dates",
      isEdit: true,
      movingOn: leadDetails?.lead?.moving_on_date
        ? `${dayjs(leadDetails?.lead?.moving_on_date).format(
            userProfile?.dateFormat ? userProfile?.dateFormat : "DD/MM/YYYY",
          )}${
            leadDetails?.lead?.moving_on_end_date
              ? ` - ${dayjs(leadDetails?.lead?.moving_on_end_date).format(
                  userProfile?.dateFormat
                    ? userProfile?.dateFormat
                    : "DD/MM/YYYY",
                )}`
              : ""
          }`
        : "N/A",
      packingOn: leadDetails?.lead?.packing_on_date
        ? dayjs(leadDetails?.lead?.packing_on_date).format(
            userProfile?.dateFormat ? userProfile?.dateFormat : "DD/MM/YYYY",
          )
        : "N/A",
      followUp: leadDetails?.lead?.follow_up_date
        ? `${dayjs
            .utc(leadDetails?.lead?.follow_up_date)
            .tz(userProfile?.timezone || "UTC")
            .format(
              userProfile?.dateFormat ? userProfile?.dateFormat : "DD/MM/YYYY",
            )}${
            leadDetails?.lead?.follow_up_end_date
              ? `, ${dayjs
                  .utc(leadDetails?.lead?.follow_up_date)
                  .tz(userProfile?.timezone || "UTC")
                  .format("HH:mm")} - ${dayjs
                  .utc(leadDetails?.lead?.follow_up_end_date)
                  .tz(userProfile?.timezone || "UTC")
                  .format("HH:mm")}`
              : ""
          }`
        : "N/A",
    },
    {
      title: "Referrer",
      // isLogo:true,
      name: `${
        leadDetails?.referrer ? leadDetails?.referrer?.name : "Unknown"
      }`,
      contact_name: `${
        leadDetails?.referrer && leadDetails?.referrer?.contact_name != null
          ? leadDetails?.referrer?.contact_name
          : "Unknown"
      }`,
      email: `${
        leadDetails?.referrer && leadDetails?.referrer?.email != null
          ? leadDetails?.referrer?.email
          : "EMail"
      }`,
    },
  ];

  const handleEditLead = (item: any) => {
    setOpen(true);
    setSelectedLead(leadDetails?.lead);
    dispatch(setNotificationAction({ message: [], severity: "error" }));
  };

  const handleEditRelevant = (item: any) => {
    setOpenRelevant(true);
    setSelectedLead(leadDetails?.lead);
    dispatch(setNotificationAction({ message: [], severity: "error" }));
  };

  const handleClose = () => {
    setOpen(false);
    setOpenRelevant(false);
    setSelectedLead(null);
  };

  return (
    <>
      {open && (
        <ManageLead
          selectLead={selectedLead}
          setSelectedLead={setSelectedLead}
          open={open}
          onHide={handleClose}
          title="Edit Lead"
        />
      )}
      {openRelevant && (
        <ManageRelevent
          selectLead={selectedLead}
          open={openRelevant}
          onHide={handleClose}
          title="Edit Relevant Date"
        />
      )}
      <Grid
        container
        // wrap="nowrap"
        spacing={2}
        sx={{
          flexDirection: { xs: "column", md: "row" },
          marginTop: "2px",
          padding: "8px 0px",
        }}
      >
        {leadCardDetailsFields &&
          leadCardDetailsFields.map((item: any, i: number) => (
            <Grid
              key={i}
              item
              xs={12}
              md={4}
              style={{
                padding: "0px 4px",
                marginBottom: "10px",
                overflowWrap: "anywhere",
              }}
            >
              <>
                <CardView
                  {...{
                    ...item,
                    isEdit:
                      (user?.user?.roles?.includes("TENANT") ||
                        user?.user?.roles?.includes("Admin") ||
                        user?.user?.roles?.includes("Owner") ||
                        (leadModulePermission?.create &&
                          user?.user?.roles?.length !== 1) ||
                        user?.user?.roles[0] !== "Surveyor") &&
                      leadDetails?.lead?.generated_id
                        ? leadDetails?.lead?.status === "COMPLETED"
                          ? false
                          : item?.isEdit
                        : false,
                    width: "100%",
                    onEditClick: leadDetails?.lead
                      ? () => {
                          i === 0
                            ? handleEditLead(item)
                            : handleEditRelevant(item);
                        }
                      : "",
                  }}
                />
              </>
            </Grid>
          ))}
      </Grid>
    </>
  );
};
export default LeadCardDetails;
